module.exports = __webpack_public_path__ + "img/waterfall-cn-1.c70a8f1.svg";